import React, { useMemo, useState } from 'react'
import { useRevision } from './hooks'
import { Button, Card, Flex, Typography } from 'antd'
import { CButton, CFormInput } from '@coreui/react-pro'
import { path } from '../../../../libs'
import { $params } from '../../../../features/router'
import { RevisionHistoryTable } from '../atoms/RevisionHistoryTable'
import { format } from 'date-fns'
import { createRevisionMounted, recalculateBalanceEvent } from './model'
import { getFinsystemNumberFormat } from '../../../../libs/utils'

export const RevisionDetails = () => {
  const [psBalance, setPsBalance] = useState('')

  const {
    revisionsHistory,
    totalCountOfRevisionsHistory,
    wallet,
    isCreateRevisionLoading,
  } = useRevision()

  const params = $params.getState()
  const crmBalance = useMemo(() => {
    let value

    wallet.localBalances.forEach((item) => {
      if (item.currency === String(params?.currency)) {
        value = item.sum
      }
    })

    return value
  }, [wallet])

  const handleChange = (event: { currentTarget: { value: any } }) => {
    const inputValue = event.currentTarget.value
    let formattedValue = inputValue.replace(',', '.') // заменяем запятую на точку
    formattedValue = formattedValue.replace(' ', '') // заменяем запятую на точку
    setPsBalance(formattedValue)
  }

  const handleCreateRevision = () => {
    if (crmBalance !== 'undefined' && crmBalance !== '') {
      createRevisionMounted({
        wallet: Number(wallet.id),
        psBalance: Number(psBalance),
        currency: String(params?.currency),
        crmBalance: Number(crmBalance) || 0,
      })
    }
    setPsBalance('')
  }

  const handleRecalculate = () => {
    recalculateBalanceEvent({
      walletId: String(wallet.id),
      currency: String(params?.currency),
      dateFrom: format(new Date(), 'yyyy-MM-dd'),
      dateTo: format(new Date(), 'yyyy-MM-dd'),
    })
  }

  return (
    <Flex vertical gap={16} align="flex-end">
      <Button
        onClick={handleRecalculate}
        color="yellow"
        variant="solid"
        style={{ color: '#000' }}
      >
        Recalculate
      </Button>
      <Card style={{ width: '100%' }}>
        <Typography.Title level={1}>{wallet.name}</Typography.Title>
        <Flex gap={50} style={{ marginBottom: '24px' }}>
          <Flex vertical>
            <Typography.Text style={{ fontSize: '18px' }} type="secondary">
              Date and time
            </Typography.Text>
            <Typography.Text style={{ margin: 0, fontSize: '18px' }}>
              {wallet.id ? format(new Date(), 'MM.dd.yyyy hh:mm') : ''}
            </Typography.Text>
          </Flex>
          <Flex vertical>
            <Typography.Text style={{ fontSize: '18px' }} type="secondary">
              Wallet
            </Typography.Text>
            <CButton
              color="link"
              style={{ margin: 0, fontSize: '18px', padding: 0 }}
              href={path.finSystem.wallets.details(String(wallet.id))}
            >
              {wallet.name}
            </CButton>
          </Flex>
          <Flex vertical>
            <Typography.Text style={{ fontSize: '18px' }} type="secondary">
              Currency
            </Typography.Text>
            <Typography.Text style={{ margin: 0, fontSize: '18px' }}>
              {String(params?.currency)}
            </Typography.Text>
          </Flex>
        </Flex>
        <Flex gap={32} style={{ marginBottom: '40px' }}>
          <Flex vertical>
            <Typography.Text style={{ fontSize: '18px' }} type="secondary">
              Balance in CRM
            </Typography.Text>
            <Typography.Text style={{ margin: 0, fontSize: '18px' }}>
              {getFinsystemNumberFormat(Number(crmBalance) || 0, 8)}
            </Typography.Text>
          </Flex>
          <Flex vertical>
            <Typography.Text style={{ fontSize: '18px' }} type="secondary">
              Balance PS
            </Typography.Text>
            <Flex gap={16}>
              <CFormInput
                width={100}
                type="text"
                id="psBalance"
                name="psBalance"
                placeholder={String(params?.currency)}
                value={psBalance}
                onChange={handleChange}
              />
              <CButton
                onClick={handleCreateRevision}
                disabled={crmBalance == 'undefined'}
              >
                {isCreateRevisionLoading ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  'Revise'
                )}
              </CButton>
            </Flex>
          </Flex>
        </Flex>
        <RevisionHistoryTable
          data={revisionsHistory}
          totalItems={totalCountOfRevisionsHistory}
          currency={String(params?.currency)}
          walletId={wallet.id}
        />
      </Card>
    </Flex>
  )
}
